import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';

const cartNotEmptyImg = 'assets/cart_black.png';
const cartEmptyImg = 'assets/cart_grey.png';
const cartWhiteImg = 'assets/cart_white.png';

@Component({
    selector: 'app-cart-badge',
    templateUrl: './cart-badge.component.html',
    styleUrls: ['./cart-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartBadgeComponent implements OnInit, OnChanges {
    @Input() numOfItems: number;
    @Input() badgeStyle: { [key: string]: string };
    @Input() badgeOffset = [];

    isCartEmpty: boolean;
    badgeImg: string;

    constructor() {
    }

    ngOnInit() {
        this.update();
    }

    update() {
        this.isCartEmpty = this.numOfItems === 0;
    }

    ngOnChanges() {
        this.update();
    }

}
